import { notificationTypes } from '@/helpers/enums';
import store from '@/store';

export const notificationOptions = {
	icon: '/logo.png',
	dir: 'rtl',
	lang: 'ar-SA',
};

export const notificationPageRedirect = [
	{ type: notificationTypes.message, redirect: '/chat', routeName: 'chat' },
	{ type: notificationTypes.attendance, redirect: '/attendance', routeName: 'attendance' },
	{ type: notificationTypes.newMark, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.newMarks, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.schedule, redirect: '/schedule', routeName: 'schedule' },
	{ type: notificationTypes.newTest, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.testsSchedule, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.transport, redirect: '/', routeName: 'home' },
	{ type: notificationTypes.notes, redirect: '/behavior', routeName: 'behavior' },
];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyA2X6tnpwzWzswyv1ONLjVwa3kmtm1Oygk',
		authDomain: 'edunix-792e3.firebaseapp.com',
		projectId: 'edunix-792e3',
		storageBucket: 'edunix-792e3.firebasestorage.app',
		messagingSenderId: '65168137653',
		appId: '1:65168137653:web:a031febd879e3e3f0dcdfc'		
	},
	publicKey: 'BBoVI-XafQ16XvwUcSsStr4JS6U3A4Rx6BVGVJkVaj9Z9ZdDAkm6_ddDyTV85oL1erSL29hI2WbBw7FTSzpSbbE',
};

export const onGetNotification = () => {
	store.dispatch('notification/fetchAll');
};
